import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=95369346&"
import script from "./Form.vue?vue&type=script&lang=js&"
export * from "./Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95369346')) {
      api.createRecord('95369346', component.options)
    } else {
      api.reload('95369346', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=95369346&", function () {
      api.rerender('95369346', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/contacts/Form.vue"
export default component.exports